import gql from 'graphql-tag';

export const YearbookExportDetails = gql`
  fragment YearbookExportDetails on YearbookExport {
    id
    album_folder {
      id
    }
    album {
      id
    }
    status
    settings {
      include_identities_csv
      identities_filter
      thumbnail_settings {
        width
        height
        format
        filename_pattern
      }
    }
    urls {
      zip {
        url
      }
    }
    created_at
  }
`;
